import { Link } from "react-router-dom";

export default ({ to, children, ...rest }) => {
  return (
    <Link to={`/dashboard${to}`} {...rest}>
      {children}
    </Link>
  );
};
